import React from 'react'
import { DatePicker } from '@material-ui/pickers'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

import SetWeekDialog from '../components/SetWeekDialog'

class DateFilterModal extends React.Component {
  state = {
    weekDialogOpen: false,
  }

  openWeekDialog = () => {
    this.setState({ weekDialogOpen: true })
  }

  closeWeekDialog = () => {
    this.setState({ weekDialogOpen: false })
  }

  onSetWeek = weekNumber => {
    this.closeWeekDialog()
    this.props.onSetWeek(weekNumber)
  }

  render() {
    const props = this.props

    return (
      <React.Fragment>
        {props.open && (
          <Dialog open={!this.state.weekDialogOpen} onClose={props.onClose}>
            <DialogTitle id="confirmation-dialog-title">Periodo</DialogTitle>
            <DialogContent>
              <MenuList style={{ marginTop: -10, marginBottom: 10 }}>
                {!props.oldDates && <MenuItem onClick={() => props.onSetPeriod('today')}>Hoy</MenuItem>}
                {!props.oldDates && <MenuItem onClick={() => props.onSetPeriod('yesterday')}>Ayer</MenuItem>}
                <MenuItem onClick={() => props.onSetPeriod('this-week')}>Esta semana</MenuItem>
                <MenuItem onClick={() => props.onSetPeriod('last-week')}>Semana anterior</MenuItem>
                <MenuItem onClick={this.openWeekDialog}>Elegir semana</MenuItem>
                <MenuItem onClick={() => props.onSetPeriod('this-month')}>Este mes</MenuItem>
                <MenuItem onClick={() => props.onSetPeriod('last-month')}>Mes anterior</MenuItem>
                {props.oldDates && (
                  <MenuItem onClick={() => props.onSetPeriod('two-months-ago')}>Hace dos meses</MenuItem>
                )}
              </MenuList>
              <Grid container spacing={16}>
                <Grid item>
                  <DatePicker
                    label="Desde"
                    value={props.from}
                    onChange={props.onFromDateChange}
                    // disableFuture
                    autoOk
                    cancelLabel="Cancelar"
                    format="D/M/Y"
                    maxDate={props.to ? props.to : undefined }
                    maxDateMessage="La fecha de inicio no puede ser superior a la de fin"
                  />
                </Grid>
                <Grid item>
                  <DatePicker
                    label="Hasta"
                    value={props.to}
                    onChange={props.onToDateChange}
                    disableFuture={false}
                    autoOk
                    cancelLabel="Cancelar"
                    format="D/M/Y"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              {props.onClear && <Button onClick={props.onClear}>Borrar</Button>}
              <Button onClick={props.onClose} color="primary">
                Filtrar
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.weekDialogOpen && (
          <SetWeekDialog
            onOk={this.onSetWeek}
            onCancel={this.closeWeekDialog}
            getCurrentWeek={props.getCurrentWeek}
            getStartOfWeek={props.getStartOfWeek}
            getEndOfWeek={props.getEndOfWeek}
          />
        )}
      </React.Fragment>
    )
  }
}

const styles = {
  datePicker: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial' !important",
  },
}

export default withStyles(styles)(DateFilterModal)



// WEBPACK FOOTER //
// ./src/components/DateFilterModal.js